<template>
  <el-row
    :gutter="12"
    class="leftSection margin-right-10"
  >
    <el-col
      :span="6"
      class="flex-row flex-left__top custom-label__input"
    >
      <span class="label-input width__auto">Ngày tạo: </span>
      <el-input
        placeholder="-"
        class="style-fullWidth input-border__bottom input-border__radius__0 inputBg__white"
      ></el-input>
    </el-col>
    <el-col
      :span="6"
      class="flex-row flex-left__top custom-label__input"
    >
      <span class="label-input width__auto">Ngày tạo: </span>
      <el-input
        placeholder="-"
        class="style-fullWidth input-border__bottom input-border__radius__0 inputBg__white"
      ></el-input>
    </el-col>
    <el-col
      :span="6"
      class="flex-row flex-left__top custom-label__input"
    >
      <span class="label-input width__auto">Ngày tạo: </span>
      <el-input
        placeholder="-"
        class="style-fullWidth input-border__bottom input-border__radius__0 inputBg__white"
      ></el-input>
    </el-col>
    <el-col
      :span="6"
      class="flex-row flex-left__top custom-label__input"
    >
      <span class="label-input width__auto">Ngày tạo: </span>
      <el-input
        placeholder="-"
        class="style-fullWidth input-border__bottom input-border__radius__0 inputBg__white"
      ></el-input>
    </el-col>
    <el-col
      :span="6"
      class="flex-row flex-left__top custom-label__input"
    >
      <span class="label-input width__auto">Ngày tạo: </span>
      <el-input
        placeholder="-"
        class="style-fullWidth input-border__bottom input-border__radius__0 inputBg__white"
      ></el-input>
    </el-col>
    <el-col
      :span="6"
      class="flex-row flex-left__top custom-label__input"
    >
      <span class="label-input width__auto">Ngày tạo: </span>
      <el-input
        placeholder="-"
        class="style-fullWidth input-border__bottom input-border__radius__0 inputBg__white"
      ></el-input>
    </el-col>
    <el-col
      :span="6"
      class="flex-row flex-left__top custom-label__input"
    >
      <span class="label-input width__auto">Ngày tạo: </span>
      <el-input
        placeholder="-"
        class="style-fullWidth input-border__bottom input-border__radius__0 inputBg__white"
      ></el-input>
    </el-col>
    <el-col
      :span="6"
      class="flex-row flex-left__top custom-label__input"
    >
      <span class="label-input width__auto">Ngày tạo: </span>
      <el-input
        placeholder="-"
        class="style-fullWidth input-border__bottom input-border__radius__0 inputBg__white"
      ></el-input>
    </el-col>
    <el-col
      :span="6"
      class="flex-row flex-left__top custom-label__input"
    >
      <span class="label-input width__auto">Ngày tạo: </span>
      <el-input
        placeholder="-"
        class="style-fullWidth input-border__bottom input-border__radius__0 inputBg__white"
      ></el-input>
    </el-col>
    <el-col
      :span="6"
      class="flex-row flex-left__top custom-label__input"
    >
      <span class="label-input width__auto">Ngày tạo: </span>
      <el-input
        placeholder="-"
        class="style-fullWidth input-border__bottom input-border__radius__0 inputBg__white"
      ></el-input>
    </el-col>
    <el-col
      :span="6"
      class="flex-row flex-left__top custom-label__input"
    >
      <span class="label-input width__auto">Ngày tạo: </span>
      <el-input
        placeholder="-"
        class="style-fullWidth input-border__bottom input-border__radius__0 inputBg__white"
      ></el-input>
    </el-col>

  </el-row>
</template>

<script>
export default {
  name: "filterReport",
  data () {
    return {

    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/report/filterReport.vue